import { render } from "./AlfapayButton.vue?vue&type=template&id=676249ca&ts=true"
import script from "./AlfapayButton.vue?vue&type=script&lang=ts"
export * from "./AlfapayButton.vue?vue&type=script&lang=ts"

import exportComponent from "/app/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__